import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable } from 'rxjs';
import { MedaViewComponent } from './meda-view.component';
import { OpenDocumentRequest } from './model/open-document-request';

@Injectable({
    providedIn: 'root',
})
export class MedaViewService {
    private modalService = inject(NgbModal);

    public openDocumentViewer(data: OpenDocumentRequest, filename: string, print?: boolean, viewOnly = false): Observable<string> {
        const modalMedidaView = this.modalService.open(MedaViewComponent, {
            size: 'xl',
            windowClass: 'mf-transparent-popup',
        });
        modalMedidaView.componentInstance.print = print;
        modalMedidaView.componentInstance.setdocumentFile = data.document;
        modalMedidaView.componentInstance.fileName = filename;
        modalMedidaView.componentInstance.documentType = data.document.type;
        modalMedidaView.componentInstance.viewOnly = viewOnly;
        return from(modalMedidaView.result);
    }
}
